// eslint-disable-next-line import/no-cycle
import request from '@/utils/request'

/**
 * @apiName 微信扫码登录二维码配置
 * @returns {{ appId: string, state: string, expireSeconds: number }}
 */
export function wxLoginConfig(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/token/wxLoginConfig',
    method: 'post',
    data,
  })
}

/**
 * @apiName 微信授权 code 换取已绑定账号列表 + loginKey
 * @param {{ code: string, state?: string }} data
 * @returns {{ needBind: boolean, loginKey: string, boundUsers: Array }}
 */
export function getBindUserListByCode(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/token/getBindUserListByCode',
    method: 'post',
    data,
  })
}

/**
 * @apiName 微信登录：选择账号（=选公司）直接换取正式登录态
 * @param {{ username: string, loginKey: string }} data
 */
export function weChatSelectAndLogin(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/token/weChatSelectAndLogin',
    method: 'post',
    data,
  })
}

/**
 * @apiName 微信登录：短信验证绑定并直接换取正式登录态
 * @param {{ username: string, smsCode: string, loginKey: string }} data
 */
export function weChatBindAndLogin(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/token/weChatBindAndLogin',
    method: 'post',
    data,
  })
}

/**
 * @apiName 为账号绑定微信登录（userId 不传=本人自助绑，管理员替他人绑需传 userId）
 * @param {{ userId?: string|number, code: string, state?: string }} data
 */
export function bindUserByCode(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/token/bindUserByCode',
    method: 'post',
    data,
  })
}

/**
 * @apiName 解绑微信登录（userId 不传=本人，按 token 认身份）
 * @description 注意与 login.js 的 unbindWechat（解绑微信「通知」）区分，此为解绑微信「登录」
 * @param {{ userId?: string|number }} data
 */
export function unbindWechatLogin(data = {}) {
  return request({
    url: '/admin/v1/vehicle/user/token/unbindWechat',
    method: 'post',
    data,
  })
}
